// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".things[data-v-16e7017f] {\n  max-width: 80rem;\n}", ""]);
// Exports
module.exports = exports;
